import { render } from "./SectionsDashboardSectionListItem.vue?vue&type=template&id=01336af8&scoped=true"
import script from "./SectionsDashboardSectionListItem.vue?vue&type=script&lang=js"
export * from "./SectionsDashboardSectionListItem.vue?vue&type=script&lang=js"

import "./SectionsDashboardSectionListItem.vue?vue&type=style&index=0&id=01336af8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01336af8"]])

export default __exports__